/**
 * @generated SignedSource<<b2d5716cb18e56ffed166f61b6ac3e7c>>
 * @relayHash 3cecfbb7615821c8e40083c6fe45470f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 415379c7055f7dd7927c37cd97c3f5dc8e81ba1aadad3e14f315e18cf9a535e6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "415379c7055f7dd7927c37cd97c3f5dc8e81ba1aadad3e14f315e18cf9a535e6",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
